import React from "react";
import { useQuery } from "@tanstack/react-query";
import { RetShiftAssignments } from "@opstel/RET/RetShiftAssignments";
import { ErrorState } from "@shared/common/components/State/ErrorState";
import { EmptyState } from "@shared/common/components/State/EmptyState";
import { LoadingState } from "@shared/common/components/State/LoadingState";
import { useKnopClient } from "@opstel/contexts/knopClient/useKnopClient";
import { instances } from "@opstel/query/queryKeys/instanceKeys";
import { useCurrentInstanceId } from "@shared/common/contexts/instanceMetadata/useInstanceId";
import { useKnopIsLoading } from "@shared/common/hooks/useKnopIsLoading";

export function RetShiftsWrapper(): React.JSX.Element {
  const isKnopLoading = useKnopIsLoading((state) => state.isLoading);
  const { knopClient } = useKnopClient();
  const { instanceId } = useCurrentInstanceId();
  const { data, isLoading, isError, error } = useQuery({
    queryKey: instances.current(instanceId).ret,
    queryFn: () => knopClient.getRetShifts(instanceId),
  });

  if (isKnopLoading || isLoading) return <LoadingState fullPage={false} />;
  if (isError) {
    console.log(error);
    return <ErrorState />;
  }

  if (!data) return <EmptyState />;
  return <RetShiftAssignments data={data ? data.retShifts : []} />;
}
